import React from 'react';
import SidebarUnitDesktop from "components/sidebar/components/SidebarUnitDesktop";
import {Calendar} from "assets/icons";

const TimeSheetDL = () => {
    return (
        <SidebarUnitDesktop 
            routeName={"Relevés d'heures"} 
            routeSidebar={"/timeSheet/toBeCompleted"}
            icon={Calendar}
            text="Relevés d'heures"
        />
    );
};

export default TimeSheetDL;